import {
  MaintenanceAlert,
  MaintenanceNotification,
} from '@branch-messenger/willow-ui'
import { AppError, AppLayout } from '@components/AppLayout'
import { Store } from '@store/index'
import { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

type RouterContext = {
  fireMixpanelEvent: (event: string) => void
  queryClient: QueryClient
  store: Store
}

const maintenanceComponentId = 't3bqc4bhkbh5'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => {
    return (
      <>
        <MaintenanceAlert componentId={maintenanceComponentId} />
        <MaintenanceNotification componentId={maintenanceComponentId} />
        <AppLayout />
        <ReactQueryDevtools buttonPosition="bottom-right" />
        <TanStackRouterDevtools />
      </>
    )
  },
  errorComponent: AppError,
})
